var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-4"},[_c('b-col',[_c('pdf-view',{attrs:{"path":_vm.path,"fileName":_vm.name}})],1),_c('b-col',[_vm._v(" hello ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }